<template>

    <v-container fluid class="" style="margin-top: 60px">
        <v-tabs align-with-title
                background-color="indigo"
                dark>
            <v-tabs-slider color="indigo"></v-tabs-slider>
            <!--<v-tab v-if="tableroGD" @click="pushTo('tableroGD')" class="v-tab v-tab--active" style="font-size:16px">Tablero Gestoria</v-tab>-->
            <v-tab v-if="cargaLayout" @click="pushTo('CargaLayout')" class="v-tab v-tab--active" style="font-size:16px">Carga Layout</v-tab>
            <v-tab v-if="mispendientes" @click="pushTo('MisPendientes')" class="v-tab v-tab--active" style="font-size:16px">Mis Pendientes</v-tab>
        </v-tabs>
        <!--<v-app-bar dense>
            <template v-slot:extension>
                <v-tabs>
                    <v-tab v-if="tableroGD" @click="pushTo('tableroGD')">Tablero Gestoria</v-tab>
                    <v-tab v-if="cargaLayout" @click="pushTo('CargaLayout')">Carga Layout</v-tab>

                </v-tabs>

            </template>
        </v-app-bar>-->

        <!--<v-card >-->
        <!--<v-toolbar dense>style="height: 75px;"
        <v-col lg=3 sm=4 md=4 cols=3>
            <v-list-item link @click="tableroGD()">
                <v-list-item-icon>
                    <v-icon>mdi-view-dashboard-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Tablero Gestoria</v-list-item-title>

            </v-list-item>
        </v-col>
        <v-col lg=3 sm=4 md=4 cols=3>
            <v-list-item link @click="cargaLayout()">
                <v-list-item-icon>
                    <v-icon>mdi-upload</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Carga Layout</v-list-item-title>

            </v-list-item>
        </v-col>
    </v-toolbar>-->
        <!--<v-container fluid>
        <v-row class="child-flex">
            <v-toolbar dense>
                <v-col lg="3">
                    <v-list-item link @click="tableroGD()">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Tablero Gestoria</v-list-item-title>

                    </v-list-item>

                </v-col>
                <v-col lg="3">
                    <v-spacer></v-spacer>
                    <v-list-item link @click="cargaLayout()">
                        <v-list-item-icon>
                            <v-icon>mdi-upload</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Carga Layout</v-list-item-title>

                    </v-list-item>
                </v-col>
                <div style="flex-basis: 20%">

                </div>
            </v-toolbar>
        </v-row>
    </v-container>-->
        <!--</v-card>-->


    </v-container>
</template>


<script>
    import { mapActions, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        data() {
            return {
                tableroGD:false,
                cargaLayout: false,
                mispendientes: false,
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            
        },
        methods: {
            pushTo(param) {
                switch (param) {
                    case 'tableroGD':
                        this.$router.push({ name: `tableroGD` });
                        break;
                    case 'CargaLayout':
                        this.$router.push({ name: `CargaLayout` });
                        break;
                    case 'MisPendientes':
                        this.$router.push({ name: `MainPendientes` });
                        break;
                }
            },
        },
        mounted() {
            MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '329').then(response => {

                if (response.data.length > 0) {
                    this.tableroGD = true;
                }
                MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '330').then(response1 => {
                    if (response1.data.length > 0) {
                        this.cargaLayout = true;
                    }
                });
                MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '340').then(response1 => {
                    if (response1.data.length > 0) {
                        this.mispendientes = true;
                    }
                });
            })
        }
    }

</script>

<style>
    /*.v-tabs-bar{
        float:right !important
    }*/
    /*.v-tab {
        text-transform: none !important;
    }*/
   /* .v-toolbar__content{
        height:20px
    }*/
</style>